import { useContext } from "react"
import { BoardContext } from "../context/BoardContext";

export const useBoard = () => {
  const { containerWidth, containerHeight, tileCountX, tileCountY } = useContext(BoardContext);

  return [containerWidth, containerHeight, tileCountX, tileCountY] as [number, number, number, number];
}